/*
 *
 * NotificationTemplates
 *
 */

import React from "react"
import { connect } from "react-redux"
import {
	setTitle,
	delayedDispatch,
	setBreadcrumb,
	updateCrumb,
	setLoader,
} from "store/actions"
import { push } from "connected-react-router"
import { Helmet } from "react-helmet"
import { Table } from "components"
import { notification } from "antd"
import Strings from "utils/strings"
import { API, Endpoints } from "utils/api"

class NotificationTemplates extends React.Component<any, any> {
	constructor(props: any) {
		super(props)

		this.state = {
			notificationTemplates: [],
			availableEvents: {},
		}
	}

	componentDidMount() {
		const { dispatch } = this.props

		dispatch(setTitle(""))

		delayedDispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.settings,
						route: "/settings",
						icon: "preferences",
					},
					{
						text: Strings.settings.notificationTemplates,
						icon: "notification",
					},
				],
			}))
		)

		this.getData()
	}

	componentDidUpdate() {
		const { dispatch } = this.props
		dispatch(updateCrumb())
	}

	async getData() {
		const { dispatch } = this.props

		dispatch(setLoader(true))

		try {
			const response = await API.get({
				url: Endpoints.uriNotificationTemplates(),
			})

			if (response.ok) {
				const { notificationTemplates = [], availableEvents = {} } =
					response.data.results || {}
				this.setState({ notificationTemplates, availableEvents })
			} else {
				notification.error({
					message: Strings.settings.notificationTemplates,
					description:
						response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5,
				})
			}
		} catch (err) {
			notification.error({
				message: Strings.settings.notificationTemplates,
				description: Strings.serverErrors.wentWrong,
				placement: "bottomRight",
				duration: 5,
			})
		}

		dispatch(setLoader(false))
	}

	render() {
		const { notificationTemplates = [], availableEvents = {} } = this.state
		const { dispatch } = this.props

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.settings.notificationTemplates}</title>
					<meta
						name="description"
						content={Strings.settings.notificationTemplatesDescription}
					/>
				</Helmet>
				<Table
					title={{
						icon: "notification",
						title: Strings.settings.notificationTemplates,
					}}
					data={notificationTemplates}
					columns={[
						{
							Header: Strings.fields.name,
							id: "notification_name",
							accessor: (row: any) => row.name || "-",
						},
						{
							Header: Strings.settings.notificationEvent,
							id: "notification_event",
							accessor: (row: any) =>
								availableEvents[row.event]?.label?.pt || row.event || "-",
						},
						{
							Header: Strings.settings.lastModifiedBy,
							id: "notification_last_modified",
							accessor: (row: any) => row.lastModifiedBy?.name || "-",
						},
					]}
					fullPage
					isSinglePage
					filterable
					sortable
					add={{
						onClick: () =>
							dispatch(push("/settings/notification-templates/new")),
					}}
					actions={{
						edit: (row: any) => ({
							onClick: () =>
								dispatch(push(`/settings/notification-templates/${row._id}`)),
						}),
					}}
				/>
			</React.Fragment>
		)
	}
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(NotificationTemplates)
